import { mapState, mapMutations } from 'vuex'
import { getActivityList } from '@/api/fission'
import { stringToJson } from '@/utils/tool'
import { storage } from '@/utils/storage'

export default {
  computed: {
    ...mapState(['region', 'gameName']),
  },
  methods: {
    ...mapMutations(['setLuckyDrawInfo']),
    // 获取活动配置信息
    async getActivityInfos(options = {}) {
      try {
        let params = {
          game: this.gameName,
          country: this.region,
          activityType: 2, // 活动类型  1买赠类 2抽奖类 3优惠券类 4裂变类
          activitySource: '',
        }
        if (Object.keys(options).length > 0) {
          params = {
            ...params,
            ...options,
          }
        }
        const res = await getActivityList(params)
        if (res && res.length) {
          const activity = res[0] || {}
          if (activity && activity.extraInfo) {
            activity.extraInfo = stringToJson(activity.extraInfo)
          }
          if (activity.activityType * 1 === 2) {
            this.setLuckyDrawInfo(activity)
            storage.set('drawActId', activity.activityId)
          }
          return Promise.resolve(activity)
        } else {
          return Promise.resolve({})
        }
      } catch (e) {
        return Promise.reject(e)
      }
    },
  },
}
